import { DatePickerDirective } from './datepicker.component'
// eslint-disable-next-line max-len
import { DatePickerDirective as OldDatePickerDirective } from './old-datepicker.component'
import FirmFormComponent from './firm-form/firm-form.component'
import { ngEnterDirective } from './ng-enter.directive'
import { PlategiFormComponent } from './plategi-form/plategi-form.component'
// eslint-disable-next-line max-len
import { OformlenieFormComponent } from './oformlenie-form/oformlenie-form.component'
import { ZoplFormComponent } from './zopl-form/zopl-form.component'
import { SubshetFormComponent } from './subshet-form/subshet-form.component'
import JsTableComponent from './js-table/js-table.component'
import ConvertToNumber from './convert-to-number.directive'
import { PutlistFormComponent } from './putlist-form/putlist-form.component'
// eslint-disable-next-line max-len
import { ZayFormComponent } from './zay-form/zay-form.component'
import { PlansComponent } from './plans/plans.component'
import { PlanFormComponent } from './plan-form/plan-form.component'
import { SelectObjectComponent } from './select-object/select-object.component'
import { ContractsComponent } from './contracts/contracts.component'
import { ContractFormComponent } from './contract-form/contract-form.component'
// eslint-disable-next-line max-len
import { SafetyBriefingFormComponent } from './safety-briefing-form/safety-briefing-form.component'
// eslint-disable-next-line max-len
import { TechnicalControlFormComponent } from './technical-control-form/technical-control-form.component'
import { StringToNumberDirective } from './string-to-number.directive'
// eslint-disable-next-line max-len
import { SaleOfServicesComponent } from './sale-of-services/sale-of-services.component'
import { ProstoiAvtoComponent } from './prostoi-avto/prostoi-avto.component'
import { TachographsComponent } from './tachographs/tachographs.component'
import { PricepFormComponent } from './pricep-form/pricep-form.component'
import { StringTSToDateDirective } from './ts-to-date.directive'
import { PricepsComponent } from './priceps/priceps.component'
import {
  ISOStringToDateDirective,
  DMYStringToDateDirective,
} from './string-to-date.directive'
// eslint-disable-next-line max-len
import { PircepUsageFormComponent } from './pricep-usage-form/pricep-usage-form.component'
import { DriverFormComponent } from './driver-form/driver-form.component'
import { TtnFormComponent } from './ttn-form/ttn-form.component'
import { EquipmentsComponent } from './equipments/equipments.component'
// eslint-disable-next-line max-len
import { EquipmentGroupsComponent } from './equipment-groups/equipment-groups.component'
// eslint-disable-next-line max-len
import { EquipmentItemsComponent } from './equipment-items/equipment-items.component'
import { FileReadDirective } from './file-read.directive'
import { MultipleFileReadDirective } from './multipe-file-read.directive'
import { AddGroupModal } from './add-group-modal/add-group.modal'
import { EquipmentAddModal } from './equipment-add-modal/equipment-add.modal'
// eslint-disable-next-line max-len
import { EquipmentImageViewModal } from './equipment-image-view-modal/equipment-image-view.modal'
// eslint-disable-next-line max-len
import { EquipmentImageEditModal } from './equipment-image-edit-modal/equipment-image-edit.modal'
// eslint-disable-next-line max-len
import {
  EquipmentImageDeleteModal,
  EquipmentImageDeleteModalController,
} from './equipment-image-delete-modal/equipment-image-delete.modal'
import { ZayNoteModal } from './zay-note-modal/zay-note.modal'
import UchetModal from './uchet-modal/uchet.modal'
import ZatratiModal from './zatrati-modal/zatrati.modal'
import ZatratiPayModal from './zatrati-pay-modal/zatrati-pay.modal'
import ZoplModal from './zopl-modal/zopl.modal'
import { UslModal } from './usl-modal/usl.modal'
import PutlistModal from './putlist-modal/putlist.modal'
import { AddPlanModal } from './add-plan-modal/add-plan.modal'
import { PlanModal } from './plan-modal/plan.modal'
import { ContractsModal } from './contracts-modal/contracts.modal'
import { PricepModal } from './pricep-modal/pricep.modal'
import angular from 'angular'
import { PricProbegComponent } from './pric-probeg/pric-probeg.component'
// eslint-disable-next-line max-len
import { AvtoJournalFormComponent } from './avto-journal-form/avto-journal-form.component'
// eslint-disable-next-line max-len
import { ArendaPolupricepovFormComponent } from './arenda-polupricepov-form/arenda-polupricepov-form.component'
import { SelectMonthComponent } from './select-month/select-month.component'
import { OstFuelFormComponent } from './ostfuel-form/ostfuel-form.component'
// eslint-disable-next-line max-len
import { RashodToplivaFormComponent } from './rashod-topliva-form/rashod-topliva-form.component'
// eslint-disable-next-line max-len
import { MonthProbegFormComponent } from './month-probeg-form/month-probeg-form.component'
import { OsopzmFormComponent } from './osopzm-form/osopzm-form.component'
import { Otper2NewFormComponent } from './otper2n-form/otper2n-form.component'
import { Otper2FormComponent } from './otper2-form/otper2-form.component'
import { Otper1FormComponent } from './otper1-form/otper1-form.component'
import { OtvystFormComponent } from './otvyst-form/otvyst-form.component'
import { NeoplFormComponent } from './neopl-form/neopl-form.component'
// eslint-disable-next-line max-len
import { FuelCostFormComponent } from './fuel-cost-form/fuel-cost-form.component'
import { KintransListComponent } from './kintrans-list/kintrans-list.component'
import { KintransFormComponent } from './kintrans-form/kintrans-form.component'
import KintransModal from './kintrans-modal/kintrans.modal'
// eslint-disable-next-line max-len
import { CtrlSchetFormComponent } from './ctrl-schet-form/ctrl-schet-form.component'
import { PackingFormComponent } from './packing-form/packing-form.component'
import { ZayStatusComponent } from './zay-status/zay-status.component'
import { ZaysComponent } from './zays/zays.component'
import { PutlistsComponent } from './putlists/putlists.component'
import { FirmsComponent } from './firms/firms.component'
import { OfsactComponent } from './ofsact/ofsact.component'
import { ZayFinansyComponent } from './zay-finansy/zay-finansy.component'
import { DashboardComponent } from './dashboard-component/dashboard.component'
import { StrahovanieComponent } from './strahovanie/strahovanie.component'
import { TehosmotrComponent } from './tehosmotr/tehosmotr.component'
import { TachFormComponent } from './tach-form/tach-form.component'
import { TarifiFormComponent } from './tarifi-form/tarifi-form.component'
import { SvodkaFormComponent } from './svodka-form/svodka-form.component'
import { GruzaperFormComponent } from './gruzaper-form/gruzaper-form.component'
import { PlanperFormComponent } from './planper-form/planper-form.component'
import { PergruziFormComponent } from './pergruzi-form/pergruzi-form.component'
// eslint-disable-next-line max-len
import { NepofirmeFormComponent } from './nepofirme-form/nepofirme-form.component'
import { OsfzakazFormComponent } from './osfzakaz-form/osfzakaz-form.component'
import { OsfschetFormComponent } from './osfschet-form/osfschet-form.component'
import { OnezakazFormComponent } from './onezakaz-form/onezakaz-form.component'
import { OneschetFormComponent } from './oneschet-form/oneschet-form.component'
// eslint-disable-next-line max-len
import { OnoseezakFormComponent } from './onoseezak-form/onoseezak-form.component'
// eslint-disable-next-line max-len
import { OnozakwinFormComponent } from './onozakwin-form/onozakwin-form.component'
import { AvtoFormComponent } from './avto-form/avto-form.component'
import { AvtoModal } from './avto-modal/avto.modal'
import { AllavtoFormComponent } from './allavto-form/allavto-form.component'
import { CorrectFormComponent } from './correct-form/correct-form.component'
import CorrectModal from './correct-modal/correct.modal'
// eslint-disable-next-line max-len
import { CorrectPlaceFormComponent } from './correct-place-form/correct-place-form.component'
// eslint-disable-next-line max-len
import { DriversListFormComponent } from './drivers-list-form/drivers-list-form.component'
import DriverModal from './driver-modal/driver.modal'
import { BalansFormComponent } from './balans-form/balans-form.component'
import { MenuColumnComponent } from './menu-column/menu-column.component'
import { MenuRowComponent } from './menu-row/menu-row.component'
import { focusMe } from './focus-me.directive'
import { dateGreaterThan } from './date-greater-than.directive'
// eslint-disable-next-line max-len
import { SelectAlphabetComponent } from './select-alphabet/select-alphabet.component'
import { ZayModal } from './zay-modal/zay.modal'
import { SelectNDSComponent } from './select-nds/select-nds.component'
import { parentZay } from './parent-zay.directive'

export default angular
  .module('gruz.components', [])
  .directive('datePicker', DatePickerDirective)
  .directive('ngEnter', ngEnterDirective)
  .directive('oldDatePicker', OldDatePickerDirective)
  .directive('convertToNumber', ConvertToNumber)
  .directive('stringToNumber', StringToNumberDirective)
  .directive('strTsToDate', StringTSToDateDirective)
  .directive('dmyStringToDate', DMYStringToDateDirective)
  .directive('isoStringToDate', ISOStringToDateDirective)
  .directive('fileread', FileReadDirective)
  .directive('multifileread', MultipleFileReadDirective)
  .directive('focusMe', focusMe)
  .directive('dateGreaterThan', dateGreaterThan)
  .directive('parentZay', parentZay)
  // компоненты
  .component('allavtoForm', AllavtoFormComponent)
  .component('avtoForm', AvtoFormComponent)
  .component('balansForm', BalansFormComponent)
  .component('contracts', ContractsComponent)
  .component('contractForm', ContractFormComponent)
  .component('correctForm', CorrectFormComponent)
  .component('correctPlaceForm', CorrectPlaceFormComponent)
  .component('dashboard', DashboardComponent)
  .component('driverForm', DriverFormComponent)
  .component('driversListForm', DriversListFormComponent)
  .component('firmForm', FirmFormComponent)
  .component('firms', FirmsComponent)
  .component('gruzaperForm', GruzaperFormComponent)
  .component('menuColumn', MenuColumnComponent)
  .component('menuRow', MenuRowComponent)
  .component('nepofirmeForm', NepofirmeFormComponent)
  .component('oneschetForm', OneschetFormComponent)
  .component('onoseezakForm', OnoseezakFormComponent)
  .component('onozakwinForm', OnozakwinFormComponent)
  .component('onezakazForm', OnezakazFormComponent)
  .component('osfschetForm', OsfschetFormComponent)
  .component('osfzakazForm', OsfzakazFormComponent)
  .component('ttnForm', TtnFormComponent)
  .component('pergruziForm', PergruziFormComponent)
  .component('plans', PlansComponent)
  .component('planForm', PlanFormComponent)
  .component('planperForm', PlanperFormComponent)
  .component('plategiForm', PlategiFormComponent)
  .component('putlistForm', PutlistFormComponent)
  .component('tarifiForm', TarifiFormComponent)
  .component('technicalControlForm', TechnicalControlFormComponent)
  .component('safetyBriefingForm', SafetyBriefingFormComponent)
  .component('oformlenieForm', OformlenieFormComponent)
  .component('zoplForm', ZoplFormComponent)
  .component('zayForm', ZayFormComponent)
  .component('zayFinansy', ZayFinansyComponent)
  .component('zays', ZaysComponent)
  .component('zayStatus', ZayStatusComponent)
  .component('subshetForm', SubshetFormComponent)
  .component('jsTable', JsTableComponent)
  .component('saleOfServices', SaleOfServicesComponent)
  .component('selectObject', SelectObjectComponent)
  .component('strahovanie', StrahovanieComponent)
  .component('tachographs', TachographsComponent)
  .component('tachForm', TachFormComponent)
  .component('tehosmotr', TehosmotrComponent)
  .component('ofsact', OfsactComponent)
  .component('prostoiAvto', ProstoiAvtoComponent)
  .component('pricepForm', PricepFormComponent)
  .component('priceps', PricepsComponent)
  .component('pricepUsageForm', PircepUsageFormComponent)
  .component('putlists', PutlistsComponent)
  .component('equipments', EquipmentsComponent)
  .component('equipmentGroups', EquipmentGroupsComponent)
  .component('equipmentItems', EquipmentItemsComponent)
  .component('pricProbegForm', PricProbegComponent)
  .component('avtoJournalForm', AvtoJournalFormComponent)
  .component('arendaPolupricepovForm', ArendaPolupricepovFormComponent)
  .component('selectMonth', SelectMonthComponent)
  .component('selectNds', SelectNDSComponent)
  .component('svodkaForm', SvodkaFormComponent)
  .component('ostFuelForm', OstFuelFormComponent)
  .component('rashodToplivaForm', RashodToplivaFormComponent)
  .component('monthProbegForm', MonthProbegFormComponent)
  .component('osopzmForm', OsopzmFormComponent)
  .component('otper2nForm', Otper2NewFormComponent)
  .component('otper2Form', Otper2FormComponent)
  .component('otper1Form', Otper1FormComponent)
  .component('otvystForm', OtvystFormComponent)
  .component('neoplForm', NeoplFormComponent)
  .component('fuelCostForm', FuelCostFormComponent)
  .component('kintransList', KintransListComponent)
  .component('kintransForm', KintransFormComponent)
  .component('ctrlSchetForm', CtrlSchetFormComponent)
  .component('packingForm', PackingFormComponent)
  .component('selectAlphabet', SelectAlphabetComponent)
  // модальные окна
  .service('avtoModal', AvtoModal)
  .service('addPlanModal', AddPlanModal)
  .service('contractsModal', ContractsModal)
  .service('correctModal', CorrectModal)
  .service('zayModal', ZayModal)
  .service('driverModal', DriverModal)
  .service('planModal', PlanModal)
  .service('uchetModal', UchetModal)
  .service('zatratiModal', ZatratiModal)
  .service('zatratiPayModal', ZatratiPayModal)
  .service('zoplModal', ZoplModal)
  .service('uslModal', UslModal)
  .service('putlistModal', PutlistModal)
  .service('pricepModal', PricepModal)
  .service('zayNoteModal', ZayNoteModal)
  .service('addGroupModal', AddGroupModal)
  .service('equipmentAddModal', EquipmentAddModal)
  .service('equipmentImageViewModal', EquipmentImageViewModal)
  .service('equipmentImageEditModal', EquipmentImageEditModal)
  .service('equipmentImageDeleteModal', EquipmentImageDeleteModal)
  .service('kintransModal', KintransModal)
  .controller(
    'equipmentImageDeleteModalController',
    EquipmentImageDeleteModalController
  ).name
